// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteTemplates_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/site_templates/lista — every template,
 * ordered by form slug. Unpaged on purpose: there is one row per form, and a
 * tenant has a handful of forms.
 */
import type { SiteTemplates_TemplateRow } from './SiteTemplates_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteTemplates_ListaResponseDados {
items: SiteTemplates_TemplateRow[]
}

export type SiteTemplates_ListaResponse = ApiResponse<SiteTemplates_ListaResponseDados>;

registerResponseContract('SiteTemplates_ListaResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: false },
      formulario:    { type: 'string',  required: false },
      assunto:       { type: 'string',  required: false },
      corpo:         { type: 'string',  required: false },
      destinatarios: { type: 'string',  required: false },
      copias:        { type: 'string',  required: false },
      ativo:         { type: 'boolean', required: false },
      criado_em:     { type: 'string',  required: false },
      atualizado_em: { type: 'string',  required: false },
    },
  },
})
